import React from "react";
import { Link } from "react-router-dom";
import { useMedia } from "react-use";
import { Button } from "@mui/material";
import { config as cssConfig } from "@100mslive/roomkit-react";
import imgMission from "../../../assets/images/six/careers-mission.webp";

const SixCareersMission = () => {
  const isMobile = useMedia(cssConfig.media.sm);
  return (
    <section className="events-page-landing-section events-page-careers-section-mission">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-careers-section-mission-content">
          {isMobile && <img src={imgMission} alt="" />}
          <div class="events-page-careers-section-heatder-text text-primary fw-700 mt-0 mb-10">
            Invest Without Borders
          </div>
          <div className="events-page-careers-section-header">
            <div className="events-page-careers-section-header-heading">
              Want to change the world with us?
            </div>
          </div>
          <div className="events-page-careers-section-header-text">
            At 6ix, we're not just building a platform; we're dismantling a
            financial caste system that has kept opportunities locked away from
            the many and in the hands of the few. For too long, your ability to
            invest, raise capital, or have your voice heard in the financial
            world has been determined by who you know, where you're from, or how
            much money you started with.
            <br />
            <br /> Our mission: To unlock social mobility on a global scale by
            empowering anyone from anywhere to invest, attract capital, and
            share expertise — all from one stage.
            <br />
            <br /> We're building the central hub for global investment
            activities, connecting investors, companies, and experts through our
            video-first, event-driven platform.
          </div>
          <Button
            variant="outlined"
            to="/explore"
            component={Link}
            color="primary"
            className="events6ix-btn events6ix-btn-primary mt-20"
          >
            VIEW OPENINGS
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SixCareersMission;
